/**
 * Sources of application problems
 * Used to identify and deduplicate problems from different systems
 */
export enum ProblemSourceEnum {
  /** Backend API server health issues */
  API = 'api',
  /** Thermal/receipt printer connection issues */
  PRINTER = 'printer',
  /** FiscalNet fiscal printer issues */
  FISCALNET = 'fiscalnet',
  /** WebSocket connection issues */
  WEBSOCKET = 'websocket',
  /** User session/authentication issues */
  SESSION = 'session',
  /** Network/offline issues */
  NETWORK = 'network',
  /** Data sync issues (pending operations, sync in progress) */
  SYNC = 'sync',
}
